export default __webpack_public_path__ + "static/media/LO13.645021f8.mp3";